import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component({
  components: {
    'app-navigation': async () => import('./components/the-navigation/TheNavigation.vue'),
    'app-authorization': async () => import('./components/the-login-form/TheLoginForm.vue')
  }
})
class App extends Vue {
  /**
   *
   */



  constructor(props: any) {
    super(props);
  }
  @Prop({ default: false, type: [Boolean] })
  disconnected: boolean;
  @Prop({ default: false, type: [Boolean] })
  visible: boolean;
  get coVisible(): boolean {
    return this.visible && this.$route.path !== '/verifyChanges';
  }
  get coDisconnected(): boolean {
    return this.disconnected;
  }
  set coDisconnected(value: boolean) {
    this.$emit('update:value', value)
  }

  private _clearTimeout: any;
  handleReload() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => location.reload(), 200);
  }

  handleCancel() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => this.coDisconnected = false, 200);
  }

}
export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.ts